import React, { useEffect, useState } from "react";
import "./ViewTask.scss";
import { Button, Card, CardBody, Col, Row, Spinner } from "reactstrap";
import CustomBreadCrumb from "utils/CustomBreadCrumb/CustomBreadCrumb";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import TaskApi from "Api/TaskApi";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { ToastContainer, toast } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";




const ViewTask = () => {
    document.title = "viewTask";
    const location = useLocation();
    const task = location?.state;
    const accessToken = localStorage.getItem("accessToken");
    const navigate = useNavigate();
    const { userId } = useParams();
    const userData = JSON.parse(localStorage.getItem("userData"));
    const isManager = userData?.role === 'manager';

    const taskDataLoc = location?.state

    const refinedTask = {
        ...taskDataLoc,
        status: {
            label:
                taskDataLoc.status.charAt(0).toUpperCase() +
                taskDataLoc.status.slice(1).toLowerCase(),
            value:
                taskDataLoc.status.charAt(0).toUpperCase() +
                taskDataLoc.status.slice(1).toLowerCase(),
        },
    }
    const [taskData, setTaskData] = useState(refinedTask);
    const [errors, setErrors] = useState({});
    const [updateStatus, setUpdateStatus] = useState(false)


    const breadcrumbItems = [
        { label: "Pixwik", link: "#" },
        { label: "Task", link: "#" },
        { label: "Task Details", link: "#" },
    ];

    const statusOptions = isManager
        ? [
            { label: "Not Started", value: "Not Started" },
            { label: "In Review", value: "In Review" },
            { label: "In Progress", value: "In Progress" },
            { label: "Completed", value: "Completed" }, // Manager-specific status
        ]
        : [
            { label: "Not Started", value: "Not Started" },

            { label: "In Review", value: "In Review" },
            { label: "In Progress", value: "In Progress" },
        ];

    const getTask = () => {
        const config = {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        };

        TaskApi.getAnalystTaskById(userId, config)
            .then((res) => {
                setTaskData(res.data.task);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const validateTargetCompletion = async () => {
        const config = {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        };


        TaskApi.validateTargetCompletion(taskData._id, config)
            .then((response) => {
                return response.data.isTargetComplete;
            })
            .catch((error) => {
                console.error("Error in validating target completion:", error);
                return false;
            });
    };


    //     setUpdateStatus(true)
    //     if (taskData.status.value === "In-Review" && userData.role === "data_analyst") {
    //         const isTargetComplete = await validateTargetCompletion();
    //         if (!isTargetComplete) {
    //             setErrors((prev) => ({
    //                 ...prev,
    //                 status: "Cannot change status to 'In Review' as the target is not completed.",
    //             }));
    //             return;
    //         } else {
    //             setErrors((prev) => ({ ...prev, status: null }));
    //         }
    //     }


    //     const config = {
    //         headers: {
    //             Authorization: `Bearer ${accessToken}`,
    //         },
    //     };
    //     const payload = {
    //         ...taskData, taskId: taskData._id,
    //         status: taskData.status.toLowerCase(),
    //         description: taskData.description,
    //     }



    //     TaskApi.updateTask(payload, config)
    //         .then((res) => {
    //             toast.success("Task Updated successfully")

    //             navigate(-1);
    //             setUpdateStatus(false)

    //         })
    //         .catch((err) => {
    //             console.error("Error updating task:", err);
    //             toast.error(
    //                 err.response?.data?.message || " Task update Failed"
    //             )
    //             setUpdateStatus(false)

    //         });
    // };
    const updateTask = async () => {
        setUpdateStatus(true);
        if (taskData.status.value === "In-Review" && userData.role === "data_analyst") {
            const isTargetComplete = await validateTargetCompletion();
            if (!isTargetComplete) {
                setErrors((prev) => ({
                    ...prev,
                    status: "Cannot change status to 'In Review' as the target is not completed.",
                }));
                setUpdateStatus(false);
                return;
            } else {
                setErrors((prev) => ({ ...prev, status: null }));
            }
        }

        const config = {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        };
        const payload = {
            ...taskData,
            taskId: taskData._id,
            status: taskData.status.toLowerCase(),
            description: taskData.description,
        };

        TaskApi.updateTask(payload, config)
            .then((response) => {
                setUpdateStatus(true);
                console.log("Task Updated successfully:", response.data);
                setTimeout(() => {
                    navigate(-1)
                  }, 1000)
                toast.success("Task Updated successfully");
                
                ;


            })
            .catch((error) => {
                setUpdateStatus(false);
                const errorMessage =
                    error.response && error.response.data && error.response.data.message
                        ? error.response.data.message
                        : "Unable to update status";

                toast.error(errorMessage);
                

            });
    };


    useEffect(() => {
        if (userId) {
            getTask();
        }
    }, [userId]);

    const handleChange = (field, value) => {
        setTaskData((prev) => ({ ...prev, [field]: value }));
    };

    return (

        <div className="view-task">
         <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

            <Row>

                <Col xs="12">
                    <div className="task-list-header d-flex align-items-center justify-content-between">
                        <CustomBreadCrumb data={breadcrumbItems} pageTitle="Task Details" />
                    </div>
                    <Card className="mt-4">
                        <CardBody>
                            <div className="task-details">
                                <div className="detail-row">
                                    <label htmlFor="taskName" className="label">
                                        Task Name
                                    </label>
                                    <InputText
                                        id="taskName"
                                        value={taskData.taskName}
                                        className="inp-field-box"
                                        disabled
                                    />
                                </div>
                                <div className="detail-row">
                                    <label htmlFor="taskCategory" className="label">
                                        Task Category
                                    </label>
                                    <InputText
                                        id="taskCategory"
                                        value={taskData.taskCategory}
                                        className="inp-field-box"
                                        disabled
                                    />
                                </div>
                                <div className="detail-row">
                                    <label htmlFor="priority" className="label">
                                        Priority
                                    </label>
                                    <InputText
                                        id="priority"
                                        value={taskData.priority}
                                        className="inp-field-box"
                                        disabled
                                    />
                                </div>
                                <div className="detail-row">
                                    <label htmlFor="target" className="label">
                                        Target
                                    </label>
                                    <InputText
                                        id="target"
                                        value={taskData.target}
                                        className="inp-field-box"
                                        disabled
                                    />
                                </div>
                                <div className="detail-row">
                                    <label htmlFor="startDate" className="label">
                                        Start Date
                                    </label>
                                    <InputText
                                        id="startDate"
                                        value={taskData.startDate}
                                        className="inp-field-box"
                                        disabled
                                    />
                                </div>
                                <div className="detail-row">
                                    <label htmlFor="dueDate" className="label">
                                        Due Date
                                    </label>
                                    <InputText
                                        id="dueDate"
                                        value={taskData.dueDate}
                                        className="inp-field-box"
                                        disabled
                                    />
                                </div>

                                <div className="detail-row">
                                    <label htmlFor="remarks" className="label">
                                        Remarks
                                    </label>
                                    <InputText
                                        id="remarks"
                                        value={taskData.remarks}
                                        className="inp-field-box"
                                        disabled
                                    />
                                </div>

                                <div className="detail-row">
                                    <label htmlFor="status" className="label">
                                        Status
                                    </label>
                                    <Dropdown
                                        // id="status"
                                        value={taskData.status || " "}
                                        options={statusOptions}
                                        onChange={(e) => handleChange("status", e.value)}
                                        placeholder="Select Status"
                                        className="inp-field-box"
                                    />
                                    {errors.status && (
                                        <small className="error">{errors.status}</small>
                                    )}
                                </div>
                                <div className="detail-row">
                                    <label htmlFor="description" className="label">
                                        Description
                                    </label>
                                    <InputText
                                        id="description"
                                        value={taskData.description}
                                        className="inp-field-box"
                                        onChange={(e) => handleChange('description', e.target.value)}
                                        disabled={isManager}

                                    />
                                </div>
                            </div>
                            <div className="action-buttons mt-4 d-flex align-items-center justify-content-end gap-3">
                                <Button
                                    type="button"
                                    outline
                                    color="danger"
                                    onClick={() => navigate(-1)}
                                >
                                    Back
                                </Button>
                                <Button
                                    type="button"
                                    color="secondary"
                                    onClick={updateTask}
                                >
                                    {updateStatus ? <Spinner size="sm" /> : " Save "}

                                </Button>


                            </div>


                        </CardBody>

                    </Card>

                </Col>
            </Row>





        </div>



    );
};

export default ViewTask;
